<template>
  <span>
    <template v-if="show">
      <b-button variant="link" @click="click">{{ type.label }}</b-button>
    </template>
    <template v-if="!show">{{ type.label }}</template>
  </span>
</template>
<script>
export default {
  props: {
    showLink: {
      type: Boolean,
      default: true,
      required: false
    },
    purchase: {
      type: Object,
      required: true,
      default: () => ({
        type: '',
        subscription_id: -1,
        parent_subscription_id: -1
      })
    }
  },
  computed: {
    type() {
      var types = {
        'prepaid': {
          label: 'Prepaid',
        },
        'renewal': {
          label: 'Havidíj',
          subscription_id: this.purchase.parent_subscription_id
        },
        'subscription': {
          label: 'Előfizetés',
          subscription_id: this.purchase.subscription_id
        }
      }

      return typeof types[this.purchase.type] !== 'undefined' ? types[this.purchase.type] : {label: 'Ismeretlen'}
    },
    show() {
      return this.showLink && typeof this.type.subscription_id !== 'undefined'
    }
  },
  methods: {
    click() {
      this.$emit('subscription-clicked', this.type.subscription_id)
    }
  }
}
</script>